import { render, staticRenderFns } from "./SampleLesson.vue?vue&type=template&id=f157e538"
import script from "./SampleLesson.vue?vue&type=script&lang=ts"
export * from "./SampleLesson.vue?vue&type=script&lang=ts"
import style0 from "./SampleLesson.vue?vue&type=style&index=0&id=f157e538&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports